export const HIDE_MODAL = 'modal/HIDE';

export const hideModal = payload => ({
  type: HIDE_MODAL,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/hide-modal.js